import { Grid, TextField } from "@mui/material";
import styled from "styled-components";
import { topBarSize, leftBarSize } from "../../../Components/NavBar/styles";
import PasswordInput from "../../Patients/Create/PasswordInput";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { styled as styledMUI } from "@mui/system";
import {
  DeleteForever as DeleteForeverIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from "@mui/icons-material";
import CustomSelection from "../../../Components/CustomSelection";
import CustomSelection2 from "../../../Components/CustomSelection2";

export const Container = styled.div`
  position: absolute;
  top: calc(${topBarSize});
  left: calc(${leftBarSize});

  width: calc(100% - calc(${leftBarSize} + 1.5rem)) !important;
  height: calc(100% - calc(${topBarSize} + 2rem)) !important;

  padding-top: 1rem;
  padding-left: 1rem;

  z-index: 1;
`;

export const Title = styled.p`
  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 900;
  color: rgba(55, 73, 87, 0.7);
  font-size: 2rem;

  z-index: 2;

  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -ms-flex-align: center;
  -webkit-align-items: center;
`;

export const Button = styled.button`
  position: absolute;
  right: 0%;

  height: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;

  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 900;
  color: #2e933c;

  background: none;
  border: 2px solid #2e933c;
  border-radius: 20px;

  cursor: pointer;

  &:hover {
    background: rgba(55, 73, 87, 0.1);
    transition-duration: 0.1s;
  }

  &:active {
    background: rgba(55, 73, 87, 0.2);
    transition-duration: 0.1s;
  }

  z-index: 3;
`;

export const BackButton = styled.div`
  position: absolute;
  right: 0%;

  height: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;

  text-transform: uppercase;
  font-family: "Roboto";
  font-weight: 400;
  color:rgb(255, 0, 0);

  background: none;
  border: 2px solid rgb(255, 0, 0);
  border-radius: 20px;

  cursor: pointer;

  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;    

  &:hover {
    background: rgba(55, 73, 87, 0.1);
    transition-duration: 0.1s;
  }

  &:active {
    background: rgba(55, 73, 87, 0.2);
    transition-duration: 0.1s;
  }

  z-index: 3;
`;

export const Content = styled.div`
  width: 95%;
  height: 80%;

  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  border-radius: 10px;
  padding: 5px !important;
  border: 1px solid ${(props) => props.theme.border};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
`;

export const ContentTitle = styled(Title)`
  color: rgba(55, 73, 87, 1);
  font-size: 1.6rem;
  padding-left: 1rem;
  text-transform: none;
  margin-bottom: 1rem;
`;

export const ContentBody = styled.div`
  margin-left: 2rem !important;
`;

export const ContentInput = styled(TextField)`
  margin-top: 0.5rem !important;
`;

export const ContentInputPassword = styled(PasswordInput)``;

export const ContentInputProfilePhotoIcon = styled(UploadFileIcon)`
  position: absolute;

  top: 50%;
  left: 50%;

  width: 2rem;
  height: 2rem;

  transform: translate(-50%, -50%) scale(4);

  color: rgba(255, 255, 255, 0.5);

  opacity: 1;
`;

export const ContentInputProfilePhoto = styled.div`
  border: 1px solid ${(props) => props.theme.border};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);

  position: absolute;
  top: 30%;
  left: 70%;

  transform: translate(-50%, -50%);

  border-radius: 20px;

  opacity: 0.7;

  z-index: 3;

  &:hover {
    opacity: 1;
    cursor: pointer;
    transition: all 0.2s;
  }

  &:active {
    opacity: 0.5;
  }

  & img {
    width: 100%;
    height: 100%;
    border-radius: 20px;
  }
`;

export const VersionList = styledMUI(Grid)({
  position: "absolute",
  left: "5%",
  width: "90%",
  maxHeight: "41%",
  height: "41%",
  bottom: "1%",
  borderRadius: 4,
  textOverflow: "ellipsis",
  overflowY: "scroll",
  overflowX: "hidden",
  whiteSpace: "nowrap",
});

export const VersionContainer = styledMUI(Grid)({
  height: "4rem",
  margin: "1%",
  borderRadius: "10px",
  boxShadow: "4px 4px 11px 0px rgba(0, 0, 0, 0.5)",
});

export const VersionTitle = styled.p`
  position: relative;
  bottom: 100%;
  left: 5.5rem;
  color: #949aa7;
`;

export const Version = styled.p`
  position: relative;
  bottom: 100%;
  left: 5.5rem;
  font-family: "Roboto";
  color: #949aa7;
  font-size: 0.9rem;
`;

export const Icon = styled.img`
  position: relative;
  bottom: 5%;
  left: 1.5rem;
  width: 3.5rem;
  height: 3.5rem;
  border: 1px solid #00000033;
  border-radius: 10px;
`;

export const UsersIcon = styled(CustomSelection)({});
export const SoftwareIcon = styled(CustomSelection2)({});

export const CodeIcon = styled.div`
  border: 1px solid rgb(255, 154, 2);
  border-radius: 20px;
  width: 12rem;
  padding: 7px;
  margin: 10px;

  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;

  color: #374957;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    transition: all 0.1s;
  }

  &:active {
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 0.1s;
  }
`;

export const VersionRight = styled.div({
  position: "relative",
  bottom: "165%",
  height: "2.5rem",
  display: "flex",
  float: "right",
  alignItems: "center",
});

export const DeleteIcon = styledMUI(DeleteForeverIcon)({
  width: "2.5rem",
  height: "2.5rem",

  color: "#DB3A34",

  ":hover": {
    color: "#db39348b",
    transition: "all 0.2s",
    cursor: "pointer",
  },

  ":active": {
    color: "#db3934c7",
    cursor: "pointer",
  },
});

interface DeletePromptProps {
  show: boolean;
}
export const DeletePrompt = styled.div<DeletePromptProps>({
  display: "flex",
  float: "right",
  alignItems: "center",
  marginLeft: "10px",
  marginRight: "10px",
});

export const DeletePromptYes = styledMUI(CheckCircleIcon)({
  color: "#db3934c7",
  marginLeft: "10px",

  ":hover": {
    color: "#db39348b",
    transition: "all 0.2s",
    cursor: "pointer",
  },

  ":active": {
    color: "#db3934c7",
    cursor: "pointer",
  },
});

export const DeletePromptNo = styledMUI(CancelIcon)({
  color: "#2E933C",
  marginLeft: "5px",

  ":hover": {
    color: "rgb(46, 147, 60,0.5)",
    transition: "all 0.2s",
    cursor: "pointer",
  },

  ":active": {
    color: "rgb(46, 147, 60,0.7)",
    cursor: "pointer",
  },
});

export const ModalContent = styled.div`
  width: 95%;
  height: 80%;
  background-color: ${(props) => props.theme.background};

  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  border-radius: 10px;
  padding: 5px !important;
  border: 1px solid ${(props) => props.theme.border};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2);
`;
